import { useEffect } from 'react';
import { useEditor } from '../../state/store';
import { useCode } from '../../state/code-store';
import { useLuna } from '../../state/luna-store';
import { FileTree } from './FileTree';
import { TabsBar } from './TabsBar';
import { CodeEditor } from './CodeEditor';
import { LunaPanel } from '../luna/LunaPanel';

/**
 * Three-column layout for the code editor:
 *   [ FileTree ] [ Tabs + Monaco ] [ AI panel ]
 *
 * Boots the code store from the session on first mount.
 */
export function CodeMode() {
  const session = useEditor((s) => s.session);
  const initCode = useCode((s) => s.init);
  const codeSession = useCode((s) => s.session);
  const lunaOpen = useLuna((s) => s.open);
  const setLunaOpen = useLuna((s) => s.setOpen);
  const initLuna = useLuna((s) => s.init);
  const lunaSession = useLuna((s) => s.session);

  useEffect(() => {
    if (session && (!codeSession || codeSession.tenantId !== session.tenantId)) {
      void initCode(session);
    }
    if (session && (!lunaSession || lunaSession.tenantId !== session.tenantId)) {
      void initLuna(session);
    }
  }, [session, codeSession, lunaSession, initCode, initLuna]);

  return (
    <div className="flex min-h-0 flex-1">
      <FileTree />
      <div className="flex min-w-0 flex-1 flex-col">
        <TabsBar />
        <div className="flex min-h-0 flex-1 items-stretch">
          <div className="min-w-0 flex-1">
            <CodeEditor />
          </div>
          {lunaOpen && <LunaPanel />}
        </div>
      </div>
      <button
        onClick={() => setLunaOpen(!lunaOpen)}
        className={
          'fixed bottom-4 right-4 flex h-11 w-11 items-center justify-center rounded-full text-white shadow-modal transition-transform hover:scale-105 ' +
          (lunaOpen
            ? 'bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500'
            : 'bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-600')
        }
        title={lunaOpen ? 'Esconder Luna Intelligence' : 'Abrir Luna Intelligence'}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2M12 20v2M4 12H2M22 12h-2M6 6 4.5 4.5M19.5 19.5 18 18M6 18l-1.5 1.5M19.5 4.5 18 6" />
        </svg>
      </button>
    </div>
  );
}
